<template>
  <v-theme-provider root>
    <div id="app">
      <component :is="layout">
        <transition name="fade" appear>
          <router-view />
        </transition>
      </component>
    </div>
  </v-theme-provider>
</template>

<script>
/////// Directives //////
import Vue from "vue";
import vClickOutside from "v-click-outside";
import { mapActions } from "vuex";
// import VueHighlightJS from "vue-highlightjs";
// import "highlight.js/styles/default.css";
// Highlight.js languages (Only required languages)
// import css from "highlight.js/lib/languages/css";
// import javascript from "highlight.js/lib/languages/javascript";
// import vue from "vue-highlight.js/lib/languages/vue";
// Tell Vue.js to use vue-highlightjs
/*
 * Use Vue Highlight.js
 */
// Vue.use(VueHighlightJS, {
//   // Register only languages that you want
//   languages: {
//     css,
//     javascript,
//     vue
//   }
// });
Vue.use(vClickOutside);

const defaultLayout = "Default";
const authorizedLayout = "Authorized";
export default {
  computed: {
    layout() {
      return this.$route.meta.requiresAuth ? authorizedLayout : defaultLayout;
    }
  },
  methods: {
    ...mapActions("meta", { bindMeta: "bindMeta" })
  },
  mounted() {
    this.bindMeta();
  }
};
</script>
<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  //background: $bg-light0;
  //background-image: url("~@/assets/paper.jpg");
  background-color: #ababab;
  background-repeat: repeat;
  font-family: proxima-nova, sans-serif !important;
  //font-weight: 300;
  font-style: normal;
  color: $dark1;
}

// .theme--light {
//   color: $dark1;
// }

// #nav {
// 	padding: 30px;
// 	z-index: 99999;
// }

// #nav a {
// 	font-weight: bold;
// 	color: #aaaaaa !important;
// }

// #nav a.router-link-exact-active {
// 	color: #42b983;
// }
</style>
